module.exports = __webpack_public_path__ + "static/media/21.633edb5c.jpg";